// extracted by mini-css-extract-plugin
module.exports = {"l1lk5kxi":"l1lk5kxi","wiggleLeft-l1lk5kxi":"wiggleLeft-l1lk5kxi","wiggleRight-l1lk5kxi":"wiggleRight-l1lk5kxi"};